import React from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";

import {
  SectionHeader,
  SectionBody,
  LinkToRegisterButton,
  Icon,
} from "src/library/components/exports";
import CONTENT from "src/library/content.json";
import { useHackathonContext } from "src/library/store/GlobalStateProvider";

type StreamTopicProps = {
  path: string;
  alt: string;
  text: string;
};

const StreamTopics = (props: StreamTopicProps) => {
  const { path, alt, text } = props;
  return (
    <ListItem disablePadding>
      <ListItemIcon>
        <Icon path={path} alt={alt} style={{ height: "50px", width: "50px" }} />
      </ListItemIcon>
      <ListItemText primary={text} />
    </ListItem>
  );
};

export default function HackathonIntro() {
  const { state } = useHackathonContext();
  const {
    landingPage: { header, body, registerText },
  } = CONTENT;

  return (
    <Container maxWidth="md">
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <SectionHeader text={header} />
        </Grid>
        {body.map((b: string, index, number) => (
          <Grid key={`intro-body-section-${index}`} item>
            <SectionBody text={b} />
          </Grid>
        ))}
        <Grid item>
          <List sx={{ pl: 2 }}>
            <StreamTopics
              path="connectathon/stream-women-icon192.png"
              alt="Women in technology stream icon"
              text="Break down barriers faced by women"
            />
            <StreamTopics
              path="connectathon/stream-indigenous-icon192.png"
              alt="Indigenous in technology stream icon"
              text="Connect Indigenous and First Nations people with sustainable careers in tech"
            />
            <StreamTopics
              path="connectathon/stream-accessibility-icon192.png"
              alt="Accessibility in technology stream icon"
              text="Create an accessible, inclusive gaming solution"
            />
          </List>
        </Grid>
        {state.registrationsAvailable && (
          <>
            <Grid item>
              <SectionBody
                text={registerText}
                style={{ fontWeight: "bold", fontSize: 20 }}
              />
            </Grid>
            <Grid item>
              <LinkToRegisterButton buttonText="Register Now" />
            </Grid>
          </>
        )}
      </Grid>
    </Container>
  );
}
